import React, { useEffect } from "react";
import { motion } from "framer-motion";
// import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ThankYou() {
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18381138155/qXeFCJqtkN8cEOvR57xE",
      });
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-xl rounded-2xl p-8 md:p-12 max-w-md w-full text-center"
      >
        <div className="flex justify-center mb-4">
          {/* <CheckCircle className="text-green-600" size={70} /> */}
          <img src="https://mhcockpit.com/Media/Logo/mh-cockpit-logo-black-and-grey.webp" alt="MH Cockpit Logo" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          Thank You!
        </h1>

        <p className="text-gray-600 mt-3 text-sm md:text-base leading-relaxed">
          Your form has been submitted successfully.  
          Our team from <strong>MH Cockpit</strong> will contact you shortly.
        </p>

        <div className="mt-6">
          <Link
            to="/"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-8 rounded-lg shadow-md transition"
          >
            Go Back Home
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
